import * as React from "react";
const SvgRiot = (props) => /* @__PURE__ */ React.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 140 140", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", xmlSpace: "preserve", "xmlns:serif": "http://www.serif.com/", style: {
  fillRule: "evenodd",
  clipRule: "evenodd",
  strokeLinejoin: "round",
  strokeMiterlimit: 2
}, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M83.998,0.28L0,39.18L20.93,118.831L36.858,116.875L32.478,66.793L37.708,64.463L46.74,115.659L73.963,112.317L69.123,57.038L74.303,54.734L84.236,111.058L111.773,107.673L106.475,47.08L111.713,44.75L122.573,106.347L149.796,103.004L149.796,16.762L83.998,0.28ZM85.971,121.085L87.357,128.925L149.797,139.335L149.797,113.244L86.005,121.084L85.971,121.085Z", style: {
  fill: "#ffffff"
} }));
export default SvgRiot;
